import React from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components/macro";
import pathToRegexp from "path-to-regexp";

import Config from "../Config/profile.json";

// This might be the largest clug of a file, but there is not a better way to do this (at least in my mind)
// A simple component that shows the pathname of the current location
class Breadcrumbs extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired
  };

  render() {
    const { location } = this.props;
    let usage = pathToRegexp("/:bit/");
    let len = pathToRegexp("/:bit/:usage/");
    let price = pathToRegexp("/:bit/:usage/:leng/");
    let hex = pathToRegexp("/:bit/:usage/:leng/:hex/");

    const usagePath = location.pathname.match(usage);
    const lenPath = location.pathname.match(len);
    const pricePath = location.pathname.match(price);
    const xPath = location.pathname.match(hex);

    if (location.pathname !== "/") {
      if (usagePath != null) {
        const usageBit = usagePath[1].split("-");
        const usageB1 = usageBit[0];
        const usageB2 = usageBit[1];
        const usageName = Config.find(aaa => aaa.Slug === usageB1);
        let usageArr = [];
        usageName.Type.map((bbb, i) => {
          usageArr[i] = { Slug: bbb.slug, Name: bbb.profile };
          return false;
        });
        const usagepro = usageArr.find(ccc => ccc.Slug === `${usageB2}`);
        return (
          <Nav>
            <ul>
              <Link to={`/`}>
                <li>{usageName.Name + " " + usagepro.Name}</li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
            </ul>
          </Nav>
        );
      }
      if (lenPath != null) {
        const lenBit = lenPath[1].split("-");
        const lenB1 = lenBit[0];
        const lenB2 = lenBit[1];
        const lenName = Config.find(aaa => aaa.Slug === lenB1);
        let lenArr = [];
        lenName.Type.map((bbb, i) => {
          lenArr[i] = { Slug: bbb.slug, Name: bbb.profile };
          return false;
        });
        const lenpro = lenArr.find(ccc => ccc.Slug === `${lenB2}`);
        return (
          <Nav>
            <ul>
              <li>
                <Link to={`/`}>{lenName.Name + " " + lenpro.Name}</Link>
              </li>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
              <li>
                <Link to={`/${lenPath[1]}`}>{lenPath[2]}</Link>
              </li>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
            </ul>
          </Nav>
        );
      }
      if (pricePath != null) {
        const priceBit = pricePath[1].split("-");
        const priceB1 = priceBit[0];
        const priceB2 = priceBit[1];
        const priceName = Config.find(aaa => aaa.Slug === priceB1);
        let priceArr = [];
        priceName.Type.map((bbb, i) => {
          priceArr[i] = { Slug: bbb.slug, Name: bbb.profile };
          return false;
        });
        const pricepro = priceArr.find(ccc => ccc.Slug === `${priceB2}`);
        return (
          <Nav>
            <ul>
              <Link to={`/`}>
                <li>{priceName.Name + " " + pricepro.Name}</li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
              <Link to={`/${pricePath[1]}/`}>
                <li>{pricePath[2]}</li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
              <Link to={`/${pricePath[1]}/${pricePath[2]}/`}>
                <li>
                  {pricePath[3]
                    .replace(/25mm/gi, "1-inch")
                    .replace(/29mm/gi, "1-inch")
                    .replace(/49mm/gi, "2-inch")
                    .replace(/50mm/gi, "2-inch")}
                </li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
            </ul>
          </Nav>
        );
      }
      if (hex != null) {
        const hexBit = xPath[1].split("-");
        const hexB1 = hexBit[0];
        const hexB2 = hexBit[1];
        const hexName = Config.find(aaa => aaa.Slug === hexB1);
        let hexArr = [];
        hexName.Type.map((bbb, i) => {
          hexArr[i] = { Slug: bbb.slug, Name: bbb.profile };
          return false;
        });
        const hexpro = hexArr.find(ccc => ccc.Slug === `${hexB2}`);
        return (
          <Nav>
            <ul>
              <Link to={`/`}>
                <li>{hexName.Name + " " + hexpro.Name}</li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
              <Link to={`/${xPath[1]}/${xPath[2]}/${xPath[3]}/`}>
                <li>
                  {xPath[4]
                    .replace(/x/gi, " ")
                    .replace(/\+/gi, "/")
                    .replace(/in/gi, " in")}
                </li>
              </Link>
              {xPath[4] !== "x" && (
                <img
                  src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                  alt="arrow"
                />
              )}
              <Link to={`/${xPath[1]}/`}>
                <li>{xPath[2]}</li>
              </Link>
              <img
                src="https://cdn.wihatoolsus.com/flags/arrow.svg"
                alt="arrow"
              />
              <Link to={`/${xPath[1]}/${xPath[2]}/`}>
                <li>
                  {xPath[3]
                    .replace(/25mm/gi, "1-inch")
                    .replace(/29mm/gi, "1-inch")
                    .replace(/49mm/gi, "2-inch")
                    .replace(/50mm/gi, "2-inch")}
                </li>
              </Link>
            </ul>
          </Nav>
        );
      }
    }
    return null;
  }
}

export default withRouter(Breadcrumbs);

const Nav = styled.nav`
  max-width: 57rem;
  margin: 0 auto;
  font-size: 0.7rem;
  ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
    margin-left: 0.5rem;

    li {
      font-weight: bold;
      text-transform: uppercase;

      color: #999999;
      margin: 0;
      position: relative;
      a {
        color: #999999;
      }
    }
    @media (max-width: 57rem) {
      margin-top: 1rem;
      justify-content: center;
    }
  }
`;
